import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

export const useDetectSource = () => {
  const [isComingFromWhatsApp, setIsComingFromWhatsApp] = useState(false);
  const param = useParams();
  const location = useLocation();

  const awb = param.awbInfo;
  const encoded = base64_encode(awb);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const externalSource = searchParams.get("source");

    const isWhatsapp = externalSource === "V2hhdHNBcHA=";
    const templateId = searchParams.get("templateId");
    const decodedTemplateId =
      templateId !== null || templateId !== undefined ? base64_decode(templateId) : null;

    if (decodedTemplateId !== null) {
    }

    if (isWhatsapp) {
      const otp = encoded;
      sessionStorage.setItem("otp", otp);
      setIsComingFromWhatsApp(true);
    }
  }, []);

  return { isComingFromWhatsApp, otp: encoded };
};
